module.exports = __webpack_public_path__ + "static/media/mail_darkbleu.dec00f48.svg";